import { useTranslation } from "react-i18next";
import { ModifyDetail } from "../../../../redux/apiSpecifications/apiSubjects";
import { useMemo } from "react";

type SubjectUpdatedAddressDescritpionDetails = {
    address_type: string;
    address_new: string;
    address_old: string;
  };

interface ISubjectUpdatedAddressDescritpionProps {
  modifyDetailsJson: ModifyDetail[];
}

const SubjectUpdatedAddressDescritpion = ({
  modifyDetailsJson,
}: ISubjectUpdatedAddressDescritpionProps) => {
      const { t } = useTranslation();
    
      const getAddressTypeLabel = (code: string): string => {
        const translations: Record<string, string> = {
          D: t("address-type-D"),
          R: t("address-type-R"), 
          S: t("address-type-S"),
          L: t("address-type-L"),
          O: t("address-type-O"),
          A: t("address-type-A"),
        };
      
        return translations[code] || code;
      };

        const subjectUpdatedAddressDetails: SubjectUpdatedAddressDescritpionDetails =
        useMemo(() => {
          return {
            address_type: getAddressTypeLabel(
              modifyDetailsJson.find((_) => _.key === "address_type")?.value ?? ""
            ),
            address_old: modifyDetailsJson.find((_) => _.key === "address-old")?.value ?? "",
            address_new: modifyDetailsJson.find((_) => _.key === "address-new")?.value ?? "",
          };
        }, [modifyDetailsJson, t]);


  return <> {t("HISTORY-TEMPLATES.policy-subject-modified-address-description", {
    address_type: subjectUpdatedAddressDetails.address_type,
    address_old: subjectUpdatedAddressDetails.address_old,
    address_new: subjectUpdatedAddressDetails.address_new,
  })}</>;
};
export default SubjectUpdatedAddressDescritpion;
